import { render } from "./AttendanceToast.vue?vue&type=template&id=700b39b2&scoped=true"
import script from "./AttendanceToast.vue?vue&type=script&lang=js"
export * from "./AttendanceToast.vue?vue&type=script&lang=js"

import "./AttendanceToast.vue?vue&type=style&index=0&id=700b39b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700b39b2"]])

export default __exports__